import React from 'react'

// The Morsel fork-and-plate mark from the logo
const MorselFork = ({ color = '#57ad91', className = '' }) => (
  <svg viewBox="0 0 122 280" className={className} fill={color} aria-hidden="true">
    <circle cx="61" cy="56" r="52" />
    <path d="M21 106l16 8v73H21z" />
    <path d="M53 120h16v67H53z" />
    <path d="M85 114l16-8v99a24 24 0 0 1-24 24h-8v48H53v-64h24a8 8 0 0 0 8-8z" />
  </svg>
)

export default MorselFork
